import { Handle, Position } from '@xyflow/react'

// Entry point for the model axis: sits below the MLMate root and switches
// the map to browse-by-model.

export default function HubNode({ data }: { data: { hot: boolean } }) {
  return (
    <div
      className={
        'w-[150px] cursor-pointer rounded-2xl px-5 py-3 text-center transition-all ' +
        (data.hot
          ? 'bg-gradient-to-br from-brand-600 to-teal-600 shadow-glow'
          : 'border border-ink-600 bg-ink-850 hover:border-brand-500/60 hover:bg-ink-800')
      }
    >
      <Handle type="target" position={Position.Top} className="!h-2 !w-2 !border-0 !bg-ink-600" />
      <div className={'text-[15px] font-bold ' + (data.hot ? 'text-white' : 'text-white/90')}>
        🤖 Models
      </div>
      <div
        className={
          'text-[9.5px] font-medium uppercase tracking-widest ' +
          (data.hot ? 'text-white/75' : 'text-mut')
        }
      >
        browse by model
      </div>
      <Handle type="source" position={Position.Right} className="!h-2 !w-2 !border-0 !bg-ink-600" />
    </div>
  )
}
